import CurrencyConfiguration from './CurrencyConfiguration';

export default CurrencyConfiguration;
